import { z } from 'zod';

/** Идентификатор сущности. Строковый, чтобы не привязываться к UUID в коннекторах. */
export const IdSchema = z.string().min(1).max(128);
export type Id = z.infer<typeof IdSchema>;

/** Денежная сумма в минорных единицах (копейки). Никаких float. */
export const MoneySchema = z.object({
  amount: z.number().int().nonnegative(),
  currency: z.literal('RUB').default('RUB'),
});
export type Money = z.infer<typeof MoneySchema>;

export const CHANNELS = ['tma', 'mobile', 'web', 'qr_table', 'kiosk'] as const;
export const ChannelSchema = z.enum(CHANNELS);
export type Channel = z.infer<typeof ChannelSchema>;

export const LocaleSchema = z.enum(['ru', 'en']);
export type Locale = z.infer<typeof LocaleSchema>;

export const IsoDateTimeSchema = z.iso.datetime({ offset: true });

export const SemverSchema = z
  .string()
  .regex(/^\d+\.\d+\.\d+(?:-[0-9A-Za-z.-]+)?$/, 'ожидается semver, например 0.1.0');

export const ThemeModeSchema = z.enum(['light', 'dark']);
export type ThemeMode = z.infer<typeof ThemeModeSchema>;

export const EmptyRecordSchema = z.record(z.string(), z.unknown());
